import React from 'react'
import { UsuarioContext } from './UsuarioContext'
import { AuthContext } from './AuthContext'
import { ChatAPI } from '../api'
import { Alerts } from '../components/Simple'
import { LocalStorage } from '../services'
import { useLocation } from 'react-router-dom'

export const ChatContext = React.createContext({
  sttChatCtx: {
    modeChat: 'agendamentos',
    chatsAgends: [],
    chatsDirects: [],
    chatMNLP: false,
    chatMNLE: false,
    chat: null,
    limit: 10,
    maxScroll: 0,
    offset: 0,
    pesquisedAgends: false,
    pesquisedDirects: false,
  },
  loadsChat: {
    page: true,
    listChat: false,
    sendMsg: false,
    chatSelected: false,
    chatPagination: false,
  },
  actionsChatCtx: {
    // eslint-disable-next-line no-unused-vars
    BuscarChatAgendamentos: async countAll => {},
    // eslint-disable-next-line no-unused-vars
    BuscarChatDiretos: async countAll => {},
    // eslint-disable-next-line no-unused-vars
    SelectChatAgend: async idchat => {},
    // eslint-disable-next-line no-unused-vars
    SelectChatDirect: async idchat => {},
    // eslint-disable-next-line no-unused-vars
    AbrirChatDireto: async idempresa => {},
    // eslint-disable-next-line no-unused-vars
    AbrirChatPedido: async idchat => {},
    // eslint-disable-next-line no-unused-vars
    atualizarMensagem: async mensagem => {},
    // eslint-disable-next-line no-unused-vars
    handleModeChat: value => {},
    // eslint-disable-next-line no-unused-vars
    handleChatStt: (key, value) => {},
    // eslint-disable-next-line no-unused-vars
    handleLoadChat: (key, value) => {},
  },
})

export default function ChatContextProvider({ children }) {
  const location = useLocation()
  const { sttAuthCtx } = React.useContext(AuthContext)
  const { userUCtx } = React.useContext(UsuarioContext)

  const [sttChatCtx, setSttChatCtx] = React.useState({
    modeChat: 'agendamentos',
    chat: null,
    limit: 10,
    offset: 0,
    chatMNLP: false,
    chatMNLE: false,
    maxScroll: 0,
    chatsAgends: [],
    chatsDirects: [],
    pesquisedAgends: false,
    pesquisedDirects: false,
  })

  const [loadsChat, setLoadsChat] = React.useState({
    page: true,
    listChat: false,
    sendMsg: false,
    chatSelected: false,
    chatPagination: false,
  })

  React.useEffect(() => {
    if (!sttAuthCtx.isLogged) {
      setSttChatCtx(sttChatCtx => ({
        ...sttChatCtx,
        modeChat: 'agendamentos',
        chatsAgends: [],
        chatsDirects: [],
        chatMNLP: false,
        chatMNLE: false,
        chat: null,
        limit: 10,
        maxScroll: 0,
        offset: 0,
        pesquisedAgends: false,
        pesquisedDirects: false,
      }))
    }
  }, [sttAuthCtx.isLogged])

  async function CheckInbox() {
    const res = await ChatAPI.CheckInboxUser(userUCtx.usuario.idusuario)

    if (res.status) {
      if (res.retorno.chatPedido || res.retorno.chatEmpresa) {
        setSttChatCtx(sttChatCtx => ({
          ...sttChatCtx,
          chatMNLP: res.retorno.chatPedido,
          chatMNLE: res.retorno.chatEmpresa,
        }))
      } else if (sttChatCtx.chatMNLP || sttChatCtx.chatMNLE) {
        setSttChatCtx(sttChatCtx => ({ ...sttChatCtx, chatMNLP: false, chatMNLE: false }))
      }
    }
    return res
  }

  const literalsA = React.useRef(true)
  React.useEffect(() => {
    // Se tiver na tela de login, não faz a verificação de inbox (login = '/')
    const url = location.pathname
    if (sttAuthCtx.isLogged && literalsA.current && url !== '/') {
      CheckInbox().then(() => {
        literalsA.current = false
      })
    }
  }, [sttAuthCtx.isLogged, sttChatCtx.modeChat])

  async function AtualizaMensagem(idchat) {
    const req = await ChatAPI.AtualizarMensagemLida(idchat)

    if (req.error) {
      return false
    }
    return true
  }
  const actionsChatCtx = {
    BuscarChatAgendamentos: async countAll => {
      if (countAll) setLoadsChat(loadsChat => ({ ...loadsChat, listChat: true }))
      else setLoadsChat(loadsChat => ({ ...loadsChat, chatPagination: true }))
      const req = await ChatAPI.BuscarChatAgendamentos(
        userUCtx.usuario.idusuario,
        sttChatCtx.limit,
        countAll ? 0 : sttChatCtx.offset,
        countAll,
      )
      if (req.error) {
        setLoadsChat(loadsChat => ({ ...loadsChat, listChat: false, chatPagination: false }))
        setSttChatCtx(sttChatCtx => ({
          ...sttChatCtx,
          chatsAgends: [],
          pesquisedAgends: true,
          modeChat: 'agendamentos',
        }))
        return false
      }
      if (req.retorno) {
        const chatSelectedId = LocalStorage.get('chat-selected')
        let chatSelected = null
        if (chatSelectedId) {
          const reqChat = await ChatAPI.SelectChatAgendId(chatSelectedId.id)
          if (reqChat.status) {
            chatSelected = reqChat
          }
          LocalStorage.remove('chat-selected')
        }

        setSttChatCtx(sttChatCtx => ({
          ...sttChatCtx,
          pesquisedAgends: true,
          chatsAgends: countAll ? req.chat.rows : [...sttChatCtx.chatsAgends, ...req.chat.rows],
          offset: countAll ? req.chat.rows.length : sttChatCtx.offset + req.chat.rows.length,
          maxScroll: countAll ? req.chat.count : sttChatCtx.maxScroll,
          chat: chatSelected || sttChatCtx.chat,
        }))
        setLoadsChat(loadsChat => ({ ...loadsChat, listChat: false, chatPagination: false }))
      }
      return true
    },
    BuscarChatDiretos: async countAll => {
      setLoadsChat(loadsChat => ({ ...loadsChat, listChat: true }))
      const req = await ChatAPI.BuscarChatDiretos(
        userUCtx.usuario.idusuario,
        sttChatCtx.limit,
        countAll ? 0 : sttChatCtx.offset,
        countAll,
      )

      if (req.error) {
        setLoadsChat(loadsChat => ({ ...loadsChat, listChat: false }))
        setSttChatCtx(sttChatCtx => ({
          ...sttChatCtx,
          chatsDirects: [],
          pesquisedDirects: true,
          modeChat: 'diretos',
        }))
        return false
      }
      if (req.status) {
        const chatSelectedId = LocalStorage.get('chat-selected')
        let chatSelected = null
        if (chatSelectedId) {
          const reqChat = await ChatAPI.OpenChatEmpresa(
            chatSelectedId.id,
            userUCtx.usuario.idusuario,
          )
          if (reqChat.status) {
            if (reqChat.retorno.chat) {
              chatSelected = {
                ...reqChat.retorno.chat,
                pedido: { empresa: reqChat.retorno.empresa },
                chat_empresa_usuario: null,
                nomeEmpresa: reqChat.retorno.empresa.nome,
                mensagens: reqChat.retorno.chat.mensagens,
              }
            } else {
              chatSelected = {
                idchat: reqChat.retorno.chat_idchat,
                status: reqChat.retorno.status,
                createdAt: reqChat.retorno.createdAt,
                updatedAt: reqChat.retorno.updatedAt,
                abertoPor: reqChat.retorno.abertoPor,
                pedido: { empresa: reqChat.retorno.empresa },
                chat_empresa_usuario: null,
                nomeEmpresa: reqChat.retorno.empresa.nome,
                mensagens: reqChat.retorno.mensagens ? reqChat.retorno.mensagens : [],
              }
            }
            //console.log('reqChat', reqChat)
            if (
              reqChat.retorno?.chat?.mensagens?.at(-1)?.criadaPorAdmin &&
              reqChat.retorno?.chat?.mensagens?.at(-1)?.status === 'ENVIADA'
            ) {
              const at = await AtualizaMensagem(reqChat.retorno.chat.idchat)
              if (at) {
                reqChat.retorno.chat.mensagens.at(-1).status = 'LIDA'
                chatSelected = {
                  ...reqChat.retorno.chat,
                  ultimaMensagem: reqChat.retorno.chat.mensagens.at(-1),
                }
              }
            }
          }
          LocalStorage.remove('chat-selected')
        }
        let flag = false
        if (chatSelected) {
          const idx = sttChatCtx.chatsDirects.findIndex(c => c.idchat === chatSelected.idchat)
          if (idx === -1) {
            flag = true
          }
        }
        setSttChatCtx(sttChatCtx => ({
          ...sttChatCtx,
          modeChat: 'diretos',
          pesquisedDirects: true,
          chatsDirects: !flag ? req.chat.rows : [chatSelected, ...req.chat.rows],
          offset: req.chat.rows.length,
          maxScroll: req.chat.count,
          chat: chatSelected || sttChatCtx.chat,
        }))
        setLoadsChat(loadsChat => ({ ...loadsChat, listChat: false }))
      }
      return true
    },
    AbrirChatPedido: async idchat => {
      setLoadsChat(loadsChat => ({ ...loadsChat, chatSelected: true }))
      const req = await ChatAPI.SelectChatAgendId(idchat)

      if (req.status) {
        setSttChatCtx(sttChatCtx => ({ ...sttChatCtx, chat: req, modeChat: 'agendamentos' }))
      } else {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possível carregar a conversa, por favor tente novamente mais tarde.',
        )
      }

      setLoadsChat(loadsChat => ({ ...loadsChat, chatSelected: false }))
    },
    AbrirChatDireto: async idempresa => {
      setLoadsChat(loadsChat => ({ ...loadsChat, chatSelected: true }))
      if (!sttChatCtx.pesquisedDirects) {
        await actionsChatCtx.BuscarChatDiretos(true)
      }

      const req = await ChatAPI.OpenChatEmpresa(idempresa, userUCtx.usuario.idusuario)

      if (req.status) {
        const chat = {
          ...req.retorno.chat,
          pedido: { empresa: req.retorno.empresa },
          chat_empresa_usuario: null,
          nomeEmpresa: req.retorno.empresa.nome,
          mensagens: req.retorno.chat.mensagens ? req.retorno.chat.mensagens : [],
          ultimaMensagem: req.retorno.chat.mensagens?.at(-1) || null,
        }

        const idx = sttChatCtx.chatsDirects.findIndex(c => c.idchat === chat.idchat)
        if (idx === -1) {
          const newChats = [chat, ...sttChatCtx.chatsDirects]
          setSttChatCtx(sttChatCtx => ({
            ...sttChatCtx,
            chat: chat,
            chatsDirects: newChats,
            modeChat: 'diretos',
          }))
        } else {
          setSttChatCtx(sttChatCtx => ({ ...sttChatCtx, chat: chat, modeChat: 'diretos' }))
        }
      } else {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possível carregar a conversa, por favor tente novamente mais tarde.',
        )
      }

      setLoadsChat(loadsChat => ({ ...loadsChat, chatSelected: false }))
    },
    SelectChatAgend: async idchat => {
      setLoadsChat(loadsChat => ({ ...loadsChat, chatSelected: true }))
      const req = await ChatAPI.SelectChatAgendId(idchat)

      if (req.error) {
        setLoadsChat(loadsChat => ({ ...loadsChat, chatSelected: false }))
        return false
      }

      if (req.mensagens.at(-1)?.criadaPorAdmin && req.mensagens.at(-1)?.status === 'ENVIADA') {
        const at = await AtualizaMensagem(req.idchat)
        if (at) {
          req.mensagens.at(-1).status = 'LIDA'
          // const newChat = { ...req, ultimaMensagem: req.mensagens.at(-1) }

          // let newChats = []
          // let idx = null
          // newChats = sttChatCtx.chatsAgends.map((chat, index) => {
          //   if (chat.idchat === newChat.idchat) {
          //     idx = index
          //     return newChat
          //   }
          //   return chat
          // })
        }
        setSttChatCtx(sttChatCtx => ({ ...sttChatCtx, chat: req, modeChat: 'agendamentos' }))
        setLoadsChat(loadsChat => ({ ...loadsChat, chatSelected: false }))
        return true
      } else {
        setSttChatCtx(sttChatCtx => ({ ...sttChatCtx, chat: req, modeChat: 'agendamentos' }))
        setLoadsChat(loadsChat => ({ ...loadsChat, chatSelected: false }))
        return true
      }
    },
    SelectChatDirect: async idchat => {
      setLoadsChat(loadsChat => ({ ...loadsChat, chatSelected: true }))

      const req = await ChatAPI.SelectChatDirectId(idchat, userUCtx.usuario.idusuario)

      if (req.error) {
        setLoadsChat(loadsChat => ({ ...loadsChat, chatSelected: false }))
        return false
      }
      if (req.status) {
        const chat = {
          ...req.chat,
          pedido: { empresa: req.chat.chat_empresa_usuario.empresa },
          chat_empresa_usuario: null,
        }

        setSttChatCtx(sttChatCtx => ({ ...sttChatCtx, chat: chat, modeChat: 'diretos' }))
        setLoadsChat(loadsChat => ({ ...loadsChat, chatSelected: false }))
        return true
      } else {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possível carregar a conversa, por favor tente novamente mais tarde.',
        )
        setLoadsChat(loadsChat => ({ ...loadsChat, chatSelected: false }))
        return false
      }
    },
    atualizarMensagem: async mensagem => {
      if (sttChatCtx.chat.mensagens.find(msg => msg.idmensagem === mensagem.idmensagem))
        return false
      const newChat = { ...sttChatCtx.chat, mensagens: [...sttChatCtx.chat.mensagens, mensagem] }

      let newChats = []
      if (sttChatCtx.modeChat === 'agendamentos') {
        let idx = null
        newChats = sttChatCtx.chatsAgends.map((chat, index) => {
          if (chat.idchat === newChat.idchat) {
            idx = index
            return {
              ...chat,
              ultimaMensagem: mensagem,
            }
          }
          return chat
        })

        if (idx === null) {
          const newCE = {
            ...newChat,
            ultimaMensagem: mensagem,
          }

          newChats.unshift(newCE)
        } else {
          if (idx > 0) {
            const chat = newChats[idx]
            newChats.splice(idx, 1)
            newChats.unshift(chat)
          }
        }
        setSttChatCtx(sttChatCtx => ({ ...sttChatCtx, chatsAgends: newChats, chat: newChat }))
      } else {
        let idx = null
        newChats = sttChatCtx.chatsDirects.map((chat, index) => {
          if (chat.idchat === newChat.idchat) {
            idx = index
            return {
              ...chat,
              ultimaMensagem: mensagem,
            }
          }
          return chat
        })
        if (idx === null) {
          const newCE = {
            ...newChat,
            ultimaMensagem: mensagem,
          }

          newChats.unshift(newCE)
        } else {
          if (idx > 0) {
            const chat = newChats[idx]
            newChats.splice(idx, 1)
            newChats.unshift(chat)
          }
        }
        setSttChatCtx(sttChatCtx => ({ ...sttChatCtx, chatsDirects: newChats, chat: newChat }))
      }
    },
    handleChatStt: (key, value) => {
      setSttChatCtx(sttChatCtx => ({ ...sttChatCtx, [key]: value }))
    },
    handleModeChat: value => {
      setSttChatCtx(sttChatCtx => ({ ...sttChatCtx, modeChat: value }))
    },
    handleLoadChat: (key, value) => {
      setLoadsChat(loadsChat => ({ ...loadsChat, [key]: value }))
    },
  }

  return (
    <ChatContext.Provider
      value={{
        sttChatCtx,
        loadsChat,
        actionsChatCtx,
      }}
    >
      {children}
    </ChatContext.Provider>
  )
}
